export default __webpack_public_path__ + "static/4-b80f3212ba6e7028264a7f858e49d9b2.png";